export default __webpack_public_path__ + "static/media/6.5d6ba59d.jpg";